import { render, staticRenderFns } from "./InputSugestaoBarbeiros.vue?vue&type=template&id=246c2b32&"
import script from "./InputSugestaoBarbeiros.vue?vue&type=script&lang=js&"
export * from "./InputSugestaoBarbeiros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports